export type LoadingThemeLabel =
  | 'Default'
  | 'Willy Wonka full, coming soon'
  | 'Willy Wonka full, available now'
  | 'Willy Wonka bottom, coming soon'
  | 'Willy Wonka bottom, available now';

const themeMap: Map<LoadingThemeLabel, string> = new Map([
  ['Default', 'default'],
  ['Willy Wonka full, coming soon', 'willy_wonka full soon'],
  ['Willy Wonka full, available now', 'willy_wonka full available'],
  ['Willy Wonka bottom, coming soon', 'willy_wonka bottom soon'],
  ['Willy Wonka bottom, available now', 'willy_wonka bottom available'],
]);

export type ResolvedLoadingTheme = {
  themeName: string;
  themeClasses: string[];
};

export function resolveLoadingTheme(
  loadingTheme?: string,
): ResolvedLoadingTheme {
  if (!loadingTheme) {
    return { themeName: 'default', themeClasses: ['default'] };
  }

  const chosenTheme = themeMap.get(loadingTheme as LoadingThemeLabel);
  if (!chosenTheme) {
    return { themeName: 'default', themeClasses: ['default'] };
  }

  const [themeName, ...themeClasses] = chosenTheme.split(' ');
  return { themeName, themeClasses };
}

export function shouldShowLoadingSkin(options: {
  backgroundLandscapeUrl?: string;
  oompaLoompaUrl?: string;
  themeName: string;
  isAndroid: boolean;
}): boolean {
  const { backgroundLandscapeUrl, oompaLoompaUrl, themeName, isAndroid } =
    options;
  const hasThemeAssets = Boolean(backgroundLandscapeUrl || oompaLoompaUrl);
  if (!hasThemeAssets) {
    return false;
  }

  const isWillyWonka = themeName === 'willy_wonka';
  if (isWillyWonka) {
    return true;
  }

  const isSwjAndroidOnlySkin = Boolean(
    backgroundLandscapeUrl?.includes('Android'),
  );
  if (isSwjAndroidOnlySkin) {
    return isAndroid;
  }

  return false;
}
